module.exports = __webpack_public_path__ + "static/events-bg-d6558050189fbc0bd2b6ae5560255f1e.png";